<template>
	<div class="fplus-step-index noscroll">
		<!-- STEP DETAILS || STEP SETTINGS -->
		<router-view :funnelStep="step"/>
	</div>
</template>

<script>
import API from '@/api'

export default {
	name: "fplus-step-index",
	mixins: [API],
	data() {
		return {
			loading: false,
			step: null,

		}
	},
	methods: {
		async init(id, step) {
			try {
				this.loading = true;

				// (this.getSingleStepStore &&
				// parseInt(this.getSingleStepStore.funnel_id) === parseInt(id) &&
				// parseInt(this.getSingleStepStore.id) === parseInt(step)) ? this.getSingleStepStore :
				let res = await this.api.wsteps.get(id, step);

				this.$store.dispatch('setSingleStepStore', res);

				let check = await this.canHaveProducts(res['type']);

				if (check) {
					let prodRes = res.products;
					this.$store.dispatch('setProductsStore', prodRes);
				}
				this.step = res;
			} catch (e) {
				this.$error(e)
			} finally {
				this.loading = false;
			}
		},
		canHaveProducts(id) {
			if(id) {
				switch (parseInt(id)) {
					case 1:
					case 2:
					case 6:
						return true
						break;
					default:
						return false
				}
			} else return false
		},
	},
	created() {
		let {id, step} = this.$route.params;
		this.init(id, step);
	}
}
</script>

<style lang="scss" scoped>
.fplus-step-index {

}
</style>
